/** 全局业务相关的常量 **/

export const APP_DEFAULT_NETWORK_TIMEOUT = 5000; // 默认网络超时时间
export const APP_RETRY_NETWORK_TIMEOUT = 2500; // 开启 “超时重试” 时网络超时时间

export const APP_API_UNAUTH_CODE = 10011; // 接口未登录时返回的 code
export const APP_BALANCE_NOT_ENOUGH_CODE = 202000; // 账户余额不足时返回的 code
export const APP_PHONE_NOT_BIND_CODE = 203000; // 未绑定手机号时返回的 code

export const APP_PARAMS_ERROR_CODE = 10001; // 参数错误
export const APP_VIDEO_TAKE_DOWN_CODE = 201000; // 短剧已下架

export const FOLLOW_MP_MODE_FORCE = 2; // 关注公众号模式-强制关注
export const FOLLOW_MP_MODE_GUIDE = 3; // 关注公众号模式-引导关注
